export class SaveComment {
    commentText: string;
    assignmentNumber: string;

    constructor(_commentText: string, _assignmentNumber: string) {
        this.commentText = _commentText;
        this.assignmentNumber = _assignmentNumber;
    }
}